import type { IStore, IValueOrUpdater, IDevtoolsOptions } from '../interfaces';
import { devtools } from './devtools';

export default class StoresRegistry {
    private readonly stores: Map<string, IStore<any>> = new Map();

    public configureDevtools(options?: IDevtoolsOptions): void {
        devtools.configure(options, this.stores);

        if (typeof window !== 'undefined' && options.enabled) {
            (window as any).$$registry = this;
        }
    }

    public addStore(key: string, store: IStore<any>): void {
        if (this.stores.has(key)) {
            console.warn(`Store with key "${key}" will be re-defined`);
        }

        this.stores.set(key, store);
        devtools.subscribeStore(key, store);
    }

    public getKeysList(): string[] {
        return [...Array.from(this.stores.keys())];
    }

    public getKeys(): Record<string, string> {
        return this.getKeysList().reduce<Record<string, string>>((acc, key) => {
            acc[key] = key;
            return acc;
        }, {});
    }

    public getStore(key: string): IStore<any> {
        return this.stores.get(key);
    }

    public update(key: string, valueOrUpdater: IValueOrUpdater<any>): void {
        if (this.stores.has(key)) {
            this.stores.get(key).update(valueOrUpdater);
        }
    }

    public reset(): void {
        this.stores.forEach((store) => {
            store.reset();
        });
    }

    public cleanup(): void {
        this.reset();
        this.stores.clear();
    }
}

export const storesRegistry = new StoresRegistry();
